import { createSlotsContext } from '@grandvisionhq/slots';

const [CartHeaderActionSlotsProvider, useCartHeaderActionSlots] = createSlotsContext({
    displayName: 'CartHeaderActionSlotsContext'
});

export { CartHeaderActionSlotsProvider, useCartHeaderActionSlots };
//# sourceMappingURL=context.js.map
